import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosDefaultApi } from "src/lib/axios";
import { MutationConfig, queryClient } from "src/lib/react-query";
import useNotification from "src/store/Notifications/useNotification";


const deleteUsedBy = ({ usedById }: { usedById: number }): Promise<string> => {
  return axiosDefaultApi.delete(`api/UsedBy/DeleteUsedBy/${usedById}`);
};

type QueryFnType = typeof deleteUsedBy;

type UseDeleteUsedByOptions = {
  usedById: number;
  config?: MutationConfig<QueryFnType>;
};

export const useDeleteUsedBy = ({ config }: UseDeleteUsedByOptions) => {
  const { addNotification, setIsNotificationVisible } = useNotification();
  return useMutation({
    onError: (error: AxiosError<any>) => {
      if (error.response && error.response.data && error.response.data.message) {
        const responseMessage = error.response?.data.message;
        console.log(responseMessage);
        addNotification(responseMessage.toString(), 500);
        setIsNotificationVisible(true);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["getAllUsedBy"]);
      addNotification(`Η παράμετρος 'Χρήση από' Διαγράφηκε.`, 200);
      setIsNotificationVisible(true);
    },
    ...config,
    mutationFn: deleteUsedBy,
  });
};
